<div class="lst">

  <!-- ── Progress bar ──────────────────────────────── -->
  <div class="lst-progress" *ngIf="chargement">
    <div class="lst-progress__bar"></div>
  </div>

  <!-- ── Top action buttons ────────────────────────── -->
  <div class="lst-actions" *ngIf="listBtn?.length">
    <button *ngFor="let btn of listBtn" [disabled]="btn.disabled" [name]="btn.name" (click)="clickBtnHeat(btn.name)"
      class="lst-btn" [ngClass]="btn.class">
      <svg *ngIf="btn.icon" class="lst-btn__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor"
        stroke-width="2">
        <use [attr.href]="'#icon-' + btn.icon"></use>
      </svg>
      {{ btn.text }}
    </button>
  </div>

  <!-- ── Table container ───────────────────────────── -->
  <div class="lst-table-wrap" [ngStyle]="styleTab">
    <table class="lst-table">

      <!-- ── Header ────────────────────────────────── -->
      <thead>
        <tr>
          <th *ngFor="let column of displayedColumnsBrut.TableRD" [ngStyle]="getStyle(column)"
            (click)="column.sort && sortColumn(column)">
            <div class="lst-th-inner">
              <ng-container *ngIf="showFilter; else noFilterHeader">
                <span class="lst-th-label">{{ column.TableRD_Des }}</span>
                <input class="lst-search-input" [ngClass]="'inputSearch' + randomNumber" (keyup)="onkeyup()"
                  [name]="column.TableRD_Champs" />
              </ng-container>
              <ng-template #noFilterHeader>
                <span class="lst-th-label">{{ column.TableRD_Des }}</span>
                <!-- <svg *ngIf="!matSortDisabled" class="lst-sort-icon" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2">
                  <path d="M7 16V4m0 0L3 8m4-4l4 4M17 8v12m0 0l4-4m-4 4l-4-4" />
                </svg> -->
              </ng-template>
            </div>
          </th>
        </tr>
      </thead>

      <!-- ── Body ──────────────────────────────────── -->
      <tbody>
        <tr *ngFor="let row of dataSource.data ?? dataSource; let i = index" [ngClass]="'rowClass' + randomNumber"
          (click)="clickRow($event, row)" (dblclick)="dblclickRow($event, row)">

          <td *ngFor="let column of displayedColumnsBrut.TableRD" [ngStyle]="getStyle(column)"
            (click)="clickColumn($event, i)">

            <!-- ── READ-ONLY mode ─────────────────── -->
            <ng-container *ngIf="column.TableRD_ReadOnly || displayedColumnsBrut.read_Only; else editableCell">

              <!-- Type 0: text -->
              <span *ngIf="column.TableRD_Type == 0">{{ row[column.TableRD_Champs] }}</span>

              <!-- Type 1: checkbox (read-only) -->
              <label *ngIf="column.TableRD_Type == 1" class="lst-toggle lst-toggle--sm lst-toggle--readonly">
                <input type="checkbox" [name]="'input_' + column.TableRD_Champs"
                  [(ngModel)]="row[column.TableRD_Champs]" [disabled]="true" />
                <span class="lst-toggle__track"></span>
              </label>

              <!-- Type 2: select (read-only) -->
              <span *ngIf="column.TableRD_Type == 2" class="lst-select-readonly">
                {{ getTextSelect(getSelectedOption(row, column), column) }}
              </span>

              <!-- Type 4: date -->
              <span *ngIf="column.TableRD_Type == 4">{{ row[column.TableRD_Champs] | date: column.TableRD_Format
                }}</span>

              <!-- Type 5: image -->
              <span *ngIf="column.TableRD_Type == 5">
                <img class="lst-img" [src]="row[column.TableRD_Champs]" />
              </span>

              <!-- Type 6: number -->
              <span *ngIf="column.TableRD_Type == 6">{{ row[column.TableRD_Champs] | number: column.TableRD_Format
                }}</span>

              <!-- Type 7: html -->
              <div *ngIf="column.TableRD_Type == 7"
                [innerHTML]="sanitizer.bypassSecurityTrustHtml(row[column.TableRD_Champs])"></div>

              <!-- Type 8: icon -->
              <span *ngIf="column.TableRD_Type == 8" class="lst-material-icon lst-material-icon--primary">{{
                row[column.TableRD_Champs] }}</span>

              <!-- Type 9: time -->
              <span *ngIf="column.TableRD_Type == 9">{{ getNewDate(row[column.TableRD_Champs]) | date:
                column.TableRD_Format }}</span>

              <!-- Type 100: button -->
              <button *ngIf="column.TableRD_Type == 100" type="button" class="lst-btn lst-btn--primary lst-btn--sm"
                (click)="clickBtnTable(row, column.TableRD_Champs, i)">
                <span *ngIf="column.TableRD_Icon" class="lst-material-icon">{{ column.TableRD_Icon }}</span>
                <span>{{ row[column.TableRD_Champs] }}</span>
              </button>

              <!-- Type 101: link -->
              <a *ngIf="column.TableRD_Type == 101" class="lst-link" routerLink="{{ getHref(row, column) }}">
                {{ row[column.TableRD_Champs] }}
              </a>

            </ng-container>

            <!-- ── EDITABLE mode ──────────────────── -->
            <ng-template #editableCell>

              <!-- Type 0: text input -->
              <input *ngIf="column.TableRD_Type == 0" class="lst-input" [ngStyle]="getStyleInput(column)"
                [disabled]="getDisabled(row, column)" [type]="column.TableRD_Param2 || 'text'"
                [name]="'input_' + column.TableRD_Champs" [(ngModel)]="row[column.TableRD_Champs]"
                (input)="onInput($event, row, column, i)" (keydown)="onInputKeyDown($event, row, column, i)"
                (keyup)="onInputKeyup($event, row, column, i)" (blur)="onBlurInput($event, row, column, i)" />

              <!-- Type 1: toggle checkbox -->
              <label *ngIf="column.TableRD_Type == 1" class="lst-toggle lst-toggle--sm">
                <input type="checkbox" [disabled]="getDisabled(row, column)" [name]="'input_' + column.TableRD_Champs"
                  (change)="onCheckboxChange($event, row, column, i)" [(ngModel)]="row[column.TableRD_Champs]" />
                <span class="lst-toggle__track"></span>
              </label>

              <!-- Type 2: select / combobox -->
              <div *ngIf="column.TableRD_Type == 2" class="lst-select-wrap" [ngStyle]="getStyleInput(column)">
                <select class="lst-select" [name]="'select_' + column.TableRD_Champs"
                  [(ngModel)]="row[column.TableRD_Champs]" (change)="onSelectChange($event, row, column, i)">
                  <option *ngFor="let opt of column.dataSelect" [value]="getValueSelect(opt, column)">
                    {{ getTextSelect(opt, column) }}
                  </option>
                </select>
              </div>

              <!-- Type 3: search field (reserved) -->
              <div *ngIf="column.TableRD_Type == 3"></div>

              <!-- Type 4: date picker -->
              <input *ngIf="column.TableRD_Type == 4" class="lst-input" type="date" [ngStyle]="getStyleInput(column)"
                [name]="'input_' + column.TableRD_Champs" [(ngModel)]="row[column.TableRD_Champs]" />

              <!-- Type 7: html editable -->
              <div *ngIf="column.TableRD_Type == 7" [ngStyle]="getStyleInput(column)"
                [innerHTML]="row[column.TableRD_Champs]"></div>

              <!-- Type 8: clickable icon -->
              <span *ngIf="column.TableRD_Type == 8"
                class="lst-material-icon lst-material-icon--primary lst-material-icon--clickable"
                (click)="clickBtnTable(row, column.TableRD_Champs, i)">
                {{ row[column.TableRD_Champs] }}
              </span>

              <!-- Type 9: time input -->
              <input *ngIf="column.TableRD_Type == 9" class="lst-input" type="time" [ngStyle]="getStyleInput(column)"
                [name]="'input_' + column.TableRD_Champs" [(ngModel)]="row[column.TableRD_Champs]"
                (keydown)="onInputKeyDown($event, row, column, i)" (keyup)="onInputKeyup($event, row, column, i)" />

              <!-- Type 100: action button -->
              <button *ngIf="column.TableRD_Type == 100" type="button" class="lst-btn lst-btn--primary lst-btn--sm"
                (click)="clickBtnTable(row, column.TableRD_Champs, i)">
                <span *ngIf="column.TableRD_Icon" class="lst-material-icon">{{ column.TableRD_Icon }}</span>
                <span>{{ row[column.TableRD_Champs] }}</span>
              </button>

              <!-- Type 101: router link -->
              <a *ngIf="column.TableRD_Type == 101" class="lst-link" routerLink="{{ column.href }}">
                {{ row[column.TableRD_Champs] }}
              </a>

              <!-- Type 102: button with tooltip -->
              <button *ngIf="column.TableRD_Type == 102" type="button" class="lst-btn lst-btn--sm"
                [ngClass]="getClass(column)" [title]="row[column.TableRD_Champs]"
                (click)="clickBtnTable(row, column.TableRD_Champs, i)">
                <span *ngIf="column.TableRD_Icon" class="lst-material-icon">{{ column.TableRD_Icon }}</span>
                <span>{{ column.TableRD_TooltipText }}</span>
              </button>

              <!-- Type 103: icon with tooltip -->
              <span *ngIf="column.TableRD_Type == 103" class="lst-material-icon lst-material-icon--clickable"
                [ngClass]="getClass(column)" [title]="row[column.TableRD_Champs]"
                (click)="clickBtnTable(row, column.TableRD_Champs, i)">
                {{ column.TableRD_Icon }}
              </span>

              <!-- Type 104: select with row-based data -->
              <div *ngIf="column.TableRD_Type == 104" class="lst-select-wrap" [ngStyle]="getStyleInput(column)">
                <select class="lst-select" [name]="'select_' + column.TableRD_Champs"
                  [(ngModel)]="row[column.TableRD_Champs]" (change)="onSelectChange($event, row, column, i)">
                  <option *ngFor="let opt of getDataSelect(row, column, i)" [value]="getValueSelect(opt, column)">
                    {{ getTextSelect(opt, column) }}
                  </option>
                </select>
              </div>

              <!-- Type 105: autocomplete text -->
              <div *ngIf="column.TableRD_Type == 105" class="lst-autocomplete-wrap" [ngStyle]="getStyleInput(column)">
                <input class="lst-input" type="text" [disabled]="getDisabled(row, column)"
                  [name]="'input_' + column.TableRD_Champs" [(ngModel)]="row[column.TableRD_Champs]"
                  (keydown)="onInputKeyDown($event, row, column, i)" (keyup)="onInputKeyup($event, row, column, i)"
                  (blur)="onBlur($event, row, column, i)" (input)="onInput($event, row, column, i)"
                  autocomplete="off" />
                <ul class="lst-autocomplete-list" *ngIf="column.dataToShow?.length">
                  <li *ngFor="let option of column.dataToShow"
                    (mousedown)="onSelectionAutocompleteChanged({option:{value:option}}, row, column, i)">
                    {{ option }}
                  </li>
                </ul>
              </div>

            </ng-template>
          </td>
        </tr>
      </tbody>

      <!-- ── Footer ────────────────────────────────── -->
      <tfoot>
        <!-- Standard footer -->
        <tr class="lst-footer-row">
          <td *ngFor="let column of displayedColumnsBrut.TableRD" [ngStyle]="getStyle(column)">
            <span *ngIf="column.TableRD_ExpressionH?.toString().length > 0" class="lst-footer-cell">
              {{ column.TableRD_ExpressionH + ' ' }}{{ getSomme(column) | number: column.TableRD_Format }}
            </span>
          </td>
        </tr>
        <!-- Custom footers -->
        <ng-container *ngIf="displayedColumnsBrut.customFooter">
          <tr *ngFor="let footer of displayedColumnsBrut.customFooter.listeFooter">
            <td *ngFor="let c of footer.colonne" [attr.colspan]="c.colspan">
              <div [ngStyle]="c.style || {}">{{ c.text }}</div>
            </td>
          </tr>
        </ng-container>
      </tfoot>

    </table>
  </div>
</div>